export enum ELocalStorageKeys {
    UserDetails = "user_details",
    ScrapedData = "scraped_data",
    EvaireAthenaMemberMap = "evaire_athena_member_map",
    Authenticated = "authenticated",
}
